import React from 'react';
import { NavLink } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSettings, FiBox, FiLayers, FiActivity, FiTarget } = FiIcons;

export default function Navbar() {
  const navItems = [
    { path: '/config', label: 'Config', icon: FiSettings },
    { path: '/materials', label: 'Materials', icon: FiLayers },
    { path: '/items', label: 'Items', icon: FiBox },
    { path: '/calculator', label: 'Pack Calc', icon: FiActivity },
    { path: '/event-calc', label: 'Event Calc', icon: FiTarget },
  ];

  return (
    <nav className="fixed top-0 w-full z-50 bg-[#FBFBFD]/80 backdrop-blur-md border-b border-gray-200/50">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-black rounded-lg flex items-center justify-center">
            <SafeIcon icon={FiBox} className="text-white text-xl" />
          </div>
          <span className="font-semibold text-lg tracking-tight">Rox System</span>
        </div>
        
        <div className="flex gap-1 md:gap-4">
          {navItems.map((item) => (
            <NavLink 
              key={item.path} 
              to={item.path}
              className={({ isActive }) => 
                `flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                  isActive 
                    ? 'bg-black text-white shadow-md' 
                    : 'text-gray-500 hover:bg-gray-200/50 hover:text-black'
                }`
              }
            >
              <SafeIcon icon={item.icon} className="text-lg" />
              <span className="hidden md:inline">{item.label}</span>
            </NavLink>
          ))}
        </div>
      </div>
    </nav>
  );
}